import { IOrderFetch } from 'src/models/IOrder';
import { IVanFetch } from 'src/models/IVan';
import { colorSet } from 'src/theme';

const cutText = (text: string, amount: number) =>
  text.length > amount ? `${text.slice(0, amount)}...` : text;

const getNames = (dataArray: any[]) => dataArray.map(({ name }) => name);

const getNamesWithCommas = (dataArray: any[]) => {
  const array = dataArray.map(({ name }) => name);
  return array.join(', ');
};

const getListHoursAMPM = () => {
  const minuteArray: string[] = [];
  ['AM', 'PM'].forEach(time => {
    minuteArray.push(time === 'AM' ? 'Midnight' : 'Noon');
    minuteArray.push(`12:30 ${time}`);
    for (let j = 1; j < 12; j++) {
      ['00', '30'].forEach(minute => minuteArray.push(`${j}:${minute} ${time}`));
    }
  });
  return minuteArray;
};

const randomColor = (id: number) => {
  const colors = [
    '#d24057',
    '#c04fff',
    '#151c97',
    '#4b566b',
    '#DE7444',
    '#2E966F',
    '#8980ed',
    '#00ffaa',
    '#c1ff45',
    '#091b3d'
  ];
  const index = id > 9 ? id % 10 : id;
  return colors[index];
};

class EnumHelpers {
  static getNamesAndValues<T extends number>(e: any) {
    return EnumHelpers.getNames(e).map(n => ({ name: n, value: e[n] as T }));
  }

  static getNames(e: any) {
    return EnumHelpers.getObjValues(e).filter(v => typeof v === 'string') as string[];
  }

  static getValues<T extends number>(e: any) {
    return EnumHelpers.getObjValues(e).filter(v => typeof v === 'number') as T[];
  }

  static getSelectList<T extends number, U>(e: any, stringConverter: (arg: U) => string) {
    const selectList = new Map<T, string>();
    this.getValues(e).forEach(val =>
      selectList.set(val as T, stringConverter(val as unknown as U))
    );
    return selectList;
  }

  static getSelectListAsArray<T extends number, U>(e: any, stringConverter: (arg: U) => string) {
    return Array.from(this.getSelectList(e, stringConverter), value => ({
      value: value[0] as T,
      presentation: value[1]
    }));
  }

  private static getObjValues(e: any): (number | string)[] {
    return Object.keys(e).map(k => e[k]);
  }
}

const colorThemeOrder = (order: IOrderFetch) => {
  const {
    id,
    pdf_order,
    client: { driver_license },
    isOneway,
    status
  } = order;
  if (status === 'leads') return { background: colorSet.primaryGrey };
  if (status === 'deleted') return { background: 'rgba(255, 0, 0, 0.7)' };
  if (pdf_order && status === 'paid' && driver_license) return { background: colorSet.thirdGreen };
  if (status === 'paid' && driver_license) return { background: colorSet.primaryGreen };
  if (driver_license && !isOneway) return { background: colorSet.primaryBabyblue };
  if (isOneway) return { background: colorSet.primaryBiolet };
  if (status === 'blocked') return { background: colorSet.palePink };
  return { background: colorSet.primaryOrange };
};

type IFilterVan = Pick<IVanFetch, 'id' | 'location' | 'make' | 'type' | 'year'>;

const createVanURL = (filter: IFilterVan) => {
  const location = filter.location.split(' - ');
  const state = location[0].replaceAll(' ', '');
  let city;
  if (location.length > 1) city = location[1].replaceAll(' ', '');
  else city = state;
  const make = filter.make ? filter.make.replaceAll(' ', '') : '-';
  const type = filter.type ? filter.type : '-';
  const year = filter.year ? filter.year : '-';

  return `https://van.sprinter-rentals.com/van/${state}/${city}/${make}/${type}/${year}/143${filter.id}`;
};

export {
  cutText,
  getNames,
  getListHoursAMPM,
  randomColor,
  EnumHelpers,
  colorThemeOrder,
  getNamesWithCommas,
  createVanURL
};
